import React, { useState, useEffect } from "react";
import { Header } from '../../Components/Layout/Header.jsx';
import { MetaTags } from '../../Components/Layout/MetaTags.jsx';
import { RestrictedAccess } from "../../Components/Layout/RestrictedAccess.jsx";
import { NavLink } from "react-router-dom";


export function SuperKlub(props) {
    useEffect(() => {
        if (document.getElementById("loyalty")) {
            (function (d, id) {
                let js, fjs = d.getElementsByTagName('script')[0];
                if (d.getElementById(id)) {
                    loyaltyApp.init("loyalty", "mobile", "promotions/superklub");
                    return;
                }
                js = d.createElement('script'); js.id = id;
                js.async = true;
                js.onload = function () {
                    loyaltyApp.init("loyalty", "mobile", "promotions/superklub");
                };
                js.src = "https://www.supersport.hr/superklub/assets/scripts/loyalty-ui/latest/s2/main.js?t=" + casino.utils.generateMinuteTimestamp(10);
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'loyalty-ui'));
        }
    }, [props.user]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [props.route.location.pathname]);

    function renderForAnonymousUser() {
        return <>
            <div className="title"> Prijavi se kako bi vidio SuperKlub ponudu!</div>
            <div className="actions">
                {!casino.config.fromNativeApp && <NavLink to={{ pathname: props.getHomePathFn(props.route.location, '/login'), state: { from: props.route.location.pathname } }} className="login-btn">Prijavi se</NavLink>}
                {casino.config.fromNativeApp && <button className="login-btn" onClick={() => location.href = 'https://m.supersport.hr/registracija'}>Prijavi se i zaigraj</button>}
                <button className="registration-btn" onClick={() => location.href = 'https://m.supersport.hr/registracija'}>Registriraj se</button>
            </div>
            <div className="divider"></div>
            <div>
                <div className="sk-info">
                    <div className="title">Što je SuperKlub?</div>
                    <p className="large">
                        <b className="info-bold"> SuperKlub je program vjernosti za sve SuperSport i SuperCasino igrače.
                             <br/>Sve što trebaš je:
                        </b>
                    </p>
                    <div className="reasons">
                        <img src="Content/Images/Bonusi/DropsAndWins/heart.png" alt="box" />
                        <p>
                            Redovno igrati listiće iz ponude Sport ili Uživo ili SuperCasino igre
                        </p>
                    </div>
                    <hr/>
                    <div className="reasons">
                        <img src="Content/Images/Bonusi/DropsAndWins/snap2.png" alt="box" />
                        <p>
                            Rješavati zanimljive izazove koje smo zadali
                        </p>
                    </div>
                    <hr />
                    <div className="reasons">
                        <img src="Content/Images/Bonusi/DropsAndWins/box1.png" alt="box" />
                        <p>
                            Pokupiti super nagrade i bonuse
                        </p>
                    </div>
                    <hr />
                    <div className="reasons">
                        <p>
                            <b className="info-bold"> SuperKlub ima i svoju posebnu valutu - Supere. </b><br />Sakupljaj Supere rješavanjem izazova i zamijeni ih za nagrade ili bonuse koje želiš. Pridruži se zajednici casino igrača i sportskih znalaca, aktivno igraj i uživaj u SuperSport ponudi i SuperCasino igricama, a mi ćemo se pobrinuti za super nagrade. 
                            <br/>Ti igraš, mi nagrađujemo!
                        </p>
                    </div>
                </div>
            </div>
        </>
    }

    return (
        <>
            <MetaTags title="SuperKlub | SuperSport | SuperCasino" description="SuperKlub SuperSport Casino!" />
            <Header key="header" {...props} />
            <div className="no-padding grey">
                <div className="subpage-casino-superklub-banner">
                    <div className="background-container"></div>
                    <div className="content-container">
                        <div className="banner-image"></div>
                    </div>
                </div>
                <div className="subpage-casino-superklub-repeater"></div>
                <div id="page-wrapper" className="white flex-expand-1 border-on-tablet no-padding maximum margin-center" style={{ minHeight: 400 }}>
                    <div className="sk-container maximum margin-center">
                        {props && props.user && <div id="loyalty" className="loyalty"></div>}
                        {props && !props.user && renderForAnonymousUser()}
                    </div>
                </div>

            </div>
        </>
    )

}